import { __generator } from "tslib";
import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { withCursor, selectors } from '../../Stream';
import { initializeWatchSuggestions, fetchWatchSuggestionsSuccess, watchUsers, unsuggestUser, } from './actions';
import { requestSuccess } from '../../WatchButton/redux/actionCreators';
import { streamType, streamId } from './constants';
import { request } from '../../xhr';
import { normalize } from '../../redux/normalizr';
import { getUsersByUsernames } from '../../redux/users/selectors';
import { putEntities } from '../../redux/entities/actions';
import { watchSuggestionSchema } from '../schemas';
import { fakeResponse } from './fakeResponse';
var logger = ddt.createLogger('suggestions');
function getRequest(url, params) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: url,
                    params: params,
                }, fakeResponse(url))];
            case 1:
                response = _a.sent();
                logger.log('GET:response', response);
                return [2 /*return*/, response];
        }
    });
}
function postRequest(url, data) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: url,
                    data: data,
                }, fakeResponse(url))];
            case 1:
                response = _a.sent();
                logger.log('POST:response', response);
                return [2 /*return*/, response];
        }
    });
}
function handleFetchWatchSuggestions(payload) {
    var _a, cursor, limit, streamParams, params;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    streamParams: selectors.getStreamParams(state, streamId),
                    cursor: withCursor.selectors.getCursor(state, streamId),
                    limit: selectors.getItemsPerFetch(state, streamId),
                }); })];
            case 1:
                _a = _b.sent(), cursor = _a.cursor, limit = _a.limit, streamParams = _a.streamParams;
                if (!streamParams || streamParams.type !== streamType) {
                    return [2 /*return*/];
                }
                params = {
                    limit: limit,
                    cursor: cursor,
                };
                return [4 /*yield*/, call(doFetchWatchSuggestions, { params: params })];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
// Remove these usernames from the suggestion stream
function removeUsernamesFromStream(usernames) {
    var users, userids;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getUsersByUsernames, usernames)];
            case 1:
                users = _a.sent();
                if (users.length === 0) {
                    logger.error('Could not find users in the store', {
                        usernames: usernames,
                        found: users,
                    });
                    return [2 /*return*/];
                }
                userids = users.map(function (user) { return "" + user.userId; });
                return [4 /*yield*/, put(withCursor.actions.deleteItems({
                        streamId: streamId,
                        items: userids,
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleWatchUsers(action) {
    var _a, usernames, isBackfill, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, usernames = _a.usernames, isBackfill = _a.isBackfill;
                return [4 /*yield*/, call(postRequest, 'watch/multi', {
                        usernames: usernames,
                        is_backfill: isBackfill,
                    })];
            case 1:
                response = _b.sent();
                if (!(response && response.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, call(removeUsernamesFromStream, Object.keys(response.success))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                if (response && response.errorDescription) {
                    logger.error(response.errorDescription);
                }
                return [2 /*return*/];
        }
    });
}
function handleUnsuggestUser(action) {
    var data, response, userid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = action.payload;
                return [4 /*yield*/, call(postRequest, 'watch/unsuggest', data)];
            case 1:
                response = _a.sent();
                if (!response || !response.success) {
                    logger.error(response.errorDescription);
                    return [2 /*return*/];
                }
                userid = data.userid;
                return [4 /*yield*/, put(withCursor.actions.deleteItems({
                        streamId: streamId,
                        items: ["" + userid],
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function doFetchWatchSuggestions(_a) {
    var response;
    var params = _a.params;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(getRequest, 'watch/suggestions', params)];
            case 1:
                response = _b.sent();
                if (!!response) return [3 /*break*/, 3];
                return [4 /*yield*/, put(withCursor.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(fetchWatchSuggestionsSuccess(response))];
            case 4:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleFetchWatchSuggestionsSuccess(_a) {
    var _b, items, entities;
    var _c = _a.payload, results = _c.results, hasMore = _c.hasMore, cursor = _c.cursor;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _b = normalize(results, [
                    watchSuggestionSchema,
                ]), items = _b.result, entities = _b.entities;
                logger.log('Normalized', items);
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 1:
                _d.sent();
                return [4 /*yield*/, call(initializeWatchSuggestionStreamIfNeeded)];
            case 2:
                _d.sent();
                return [4 /*yield*/, put(withCursor.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        items: items,
                        hasMore: hasMore,
                        cursor: cursor,
                    }))];
            case 3:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function initializeWatchSuggestionStreamIfNeeded() {
    var isInitialized;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 1:
                isInitialized = _a.sent();
                if (!!isInitialized) return [3 /*break*/, 3];
                logger.log('Initializing watch suggestions stream');
                return [4 /*yield*/, put(withCursor.actions.initialize({
                        streamId: streamId,
                        itemsPerFetch: 10,
                        items: [],
                        hasMore: true,
                        streamParams: {
                            type: streamType,
                        },
                    }))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
export function handleWatchUserSuccess(action) {
    var username, isWatching;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                username = action.username, isWatching = action.isWatching;
                if (!isWatching) return [3 /*break*/, 2];
                // Remove them from the suggestion stream
                return [4 /*yield*/, call(removeUsernamesFromStream, [username])];
            case 1:
                // Remove them from the suggestion stream
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}
export default function userRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initializeWatchSuggestions, handleFetchWatchSuggestionsSuccess),
                    takeEvery(fetchWatchSuggestionsSuccess, handleFetchWatchSuggestionsSuccess),
                    takeEvery(watchUsers, handleWatchUsers),
                    takeEvery(unsuggestUser, handleUnsuggestUser),
                    takeEvery(withCursor.actions.STREAM__WITH_CURSOR__FETCH, handleFetchWatchSuggestions),
                    takeEvery(requestSuccess, handleWatchUserSuccess),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map